<template>
  <section>
    <Header title="Select Server" />
    <div class="info-page-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div v-if="loaded">
      <h1 class="head-title-underline">Select Server</h1>
      <h3 class="head-title-under-line-child" style="margin-bottom: 2.5em!important;">Pick one of the servers below to start!</h3>
      <GuildContainer v-if="guildCount > 0" v-on:refresh="refresh()" v-bind:editableGuilds="editableGuilds" v-bind:invitableGuilds="invitableGuilds" />
      <h4 class="no-guild-warning" v-if="!guildCount">Looks like there's nothing around?! You don't have the permission to add the bot to any of the servers you're in. But, you can still create of your own, and then invite the bot!</h4>
    </div>
  
    <Cookie />
    <Footer v-bind:shown="!loaded" />
  </section>
</template>

<script>
import Header from "@/components/Header.vue";
import Cookie from "@/components/Cookie.vue";
import Footer from "@/components/Footer.vue";
import GuildContainer from "@/components/GuildContainer.vue";
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
    Header,
    Cookie,
    Footer,
    GuildContainer
  },
  data () {
    return {
      editableGuilds: [],
      invitableGuilds: [],
      loaded: false
    };
  },
  watch: {
    login_queried () {
      if (this.login_queried && !this.authenticated) window.location.href = "/login";
    }
  },
  computed: {
    guildCount() {
      return this.editableGuilds.length + this.invitableGuilds.length;
    },
    ...mapGetters(["authenticated", "login_queried"])
  },
  methods: {
    fetchData: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/information/guild/editables`, {
        withCredentials: true,
        credentials: "same-origin",
      });

      this.editableGuilds = response.data.editableGuilds;
      this.invitableGuilds = response.data.inviteableGuilds;
      this.loaded = true;
    },
    refresh: async function () {
      this.loaded = false;
      this.editableGuilds = [];
      this.invitableGuilds = [];

      const response = await this.$axios.get(`${this.$apiBase}/v1/information/guild/editables?force=true`, {
        withCredentials: true,
        credentials: "same-origin",
      });

      this.editableGuilds = response.data.editableGuilds;
      this.invitableGuilds = response.data.inviteableGuilds;
      this.loaded = true;
    }
  },
  mounted() {
    this.fetchData();
  }
}
</script>

<style scoped>
.no-guild-warning {
  text-align: center;
  margin: 0 15%;
  margin-top: 4em;
}
</style>